/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CameraIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABMUlEQVR4nO1UW0rDUBSMPyKoRVdUFQqFeh5+XM/xAVmGUPysGNehCyhW0AVV/dcFKCfGWG68N3pD/3pgfpLcmZyZSbJsNV1mNDrdBdI7IH1H1o9FAOsbktwS5Tup/GvA8uQTN0DyaM/+i7mf5xvIetVK/r0N6cTOBAmdc+vIcgMkL38lxZAYyzOyFsZZC9iFrsTYRFELVKoRn3V6yCf9weB800Ake8By37bJ4gYRf+UiZC2QjGNn2wVIp35GvsdIOksWMFsiGZUeIx7vJws457YqK5rtIn39EsDt7gL8awnmdm84POslC1hbQhYB6XUpfqQHyQJWxZ+QtbBN/JCB5CG9RVzWdByqKbJedqsp14HOrC2WicFsib15Q6D1S+YkzJf6L4KqBJkf4lL+pqvJIvMJWItwe5EXjEYAAAAASUVORK5CYII=)
 */
export const CameraIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M7.17 4.66A3 3 0 0 1 9.85 3h4.3a3 3 0 0 1 2.68 1.66c.34.69.94 1.34 1.71 1.34H20a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1.46c.77 0 1.37-.65 1.71-1.34ZM17 13a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
